import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const CampaignConfirmationPage = lazy(
  () =>
    import(
      '@aboutyou/logic-components/src/backend-services/Campaigns/CampaignConfirmation/CampaignConfirmation'
    ).then(mod => ({default: mod.CampaignConfirmation})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
